var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"id":"mySVG"}},[_c('path',{attrs:{"fill":"none","stroke":"red","stroke-width":"3","id":"triangle","d":"M150 0 L75 200 L225 200 Z"}}),_vm._v("\n    Sorry, your browser does not support inline SVG.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }